import React, { useState, useRef, useEffect, useLayoutEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import useClickOutside from "components/Custom_Hooks/useClickOutsSide";
import { useDispatch, useSelector } from "react-redux";
import { closeModal, contraLedgerListing, contraVoucherCreate, contraVoucherUpdate, openModal, } from "redux/actions/action-creator";
import InputField from "components/Input/InputField";
import DropdownLayout_1 from "components/Dropdown/DropdownLayout_1";
import { prepareFormData, useFormHandler } from "components/Custom_Hooks/useFormHandler";
import Form from "components/Form/Form";
import MasterCreationFooter from "components/Footer/Master_Footer/MasterCreationFooter";
import { toast } from "react-toastify";
import { VoucherContraInputRow } from "./VoucherContraInputRow";
import { currencyFormate, removeCurrencyComma } from "components/Date_Formate_Utilitiy/Index";
import Total_Amount_Row from "components/Total_Amount/Total_Amount_Row";
import TableHeader from "components/Table/TableHeader";
import { usePaymentReceipt } from "components/Custom_Hooks/usePaymentReceipt";
import LedgerCreate from "pages/gatewayoftally/master/create/accounting_masters/Ledger";

const requiredFields = [
    { field: "voucher_type_name", message: "Voucher type is required" },
    // { field: "serial_no", message: "Serial number is required" },
    { field: "create_date", message: "Date is required" },
];



const RecieptPayment = ({
    data,
    setData,
    initialState,
    loading,
    isAlter,
    isView,
    isDuplicate
}) => {

    const inputFields = [
        {
            label: "",
            name: "serial_no",
            type: "text",
            isRequired: false,
            isDisabled: true,
        },
        {
            label: "Date",
            name: "create_date",
            type: "text",
            isRequired: false,
            isDisabled: false,
        },
        {
            label: "Supplier Inv/Ref No",
            name: "supplier_inv_ref",
            type: "text",
            isRequired: false,
            isDisabled: false,
        },
        {
            label: "Date",
            name: "date_payment",
            type: "text",
            isRequired: false,
            isDisabled: false,
        },
        {
            label: `Account ${data?.voucher_type_name?.toLowerCase() === "receipt" ||
                data?.select_type_of_voucher?.toLowerCase() === "receipt" ? "Dr" : "Cr"}`,
            name: "account",
            type: "text",
            isRequired: false,
            isDisabled: false,
        },
        {
            label: "Narration",
            name: "narration",
            type: "text",
            isRequired: false,
            isDisabled: false,
        },
    ];


    const dispatch = useDispatch();
    const navigate = useNavigate();

    // Input refs for all voucher types -----------------------
    const inputRefs = {
        voucher_type_name: useRef(null),
        serial_no: useRef(null),
        create_date: useRef(null),
        supplier_inv_ref: useRef(null),
        date_payment: useRef(null),
        account: useRef(null),
        narration: useRef(null),
    };

    const dynamicInputRef = useRef({});

    const [contra_account_ledger_list, setcontra_account_ledger_list] = useState([]);
    const [reciept_payment_account_ledger_list, setreciept_payment_account_ledger_list] = useState([]);
    const [nameInput, setNameInput] = useState(null);

    const modal_state = useSelector((state) => state.common.modal_state);
    const { userData } = useSelector((state) => state.auth);
    const { handleChange, handleFocus, handleBlur, handleKeyDown, setSubmitConfirm, submitConfirm,
        handleItemUpdate, handleDynamicFocus, handleDropdownClick, handleDropdownDynamicClick, handleDynamicBlur,
    } = usePaymentReceipt({
        data,
        setData,
        contra_account_ledger_list: contra_account_ledger_list || [],
        reciept_payment_account_ledger_list: reciept_payment_account_ledger_list || [],
        validations: {},
        inputRefs: inputRefs,
        dynamicInputRef: dynamicInputRef,
        setNameInput,
        isView: isView,
        isAlter: isAlter,
    });

    useEffect(() => {
        if (loading) return;

        const isManual = data.method_of_voucher_number?.toLowerCase() === "manual";
        const targetRef = isManual ? inputRefs?.serial_no : inputRefs?.create_date;

        const focusTimer = setTimeout(() => {
            if (targetRef?.current) {
                targetRef.current.focus();
                if (targetRef.current.select) {
                    targetRef.current.select();
                } else if (targetRef.current.setSelectionRange && targetRef.current.value) {
                    targetRef.current.setSelectionRange(0, targetRef.current.value.length);
                }
                setNameInput(targetRef);
            }
        }, 200);

        return () => clearTimeout(focusTimer);
    }, [data?.method_of_voucher_number, data?.voucher_type_name, loading]);

    useLayoutEffect(() => {
        // Only block refocus if a "standard" blocking modal is open
        const standardModals = [
            'ledgerCreate', 'godownCreateVoucher', 'stockItemCreate',
            'period', 'changeMode', 'configure', 'voucherTypeNameSelect',
            'dispatchDetails', 'orderDetails', 'otherVoucher', 'create_group_under',
            'create_under', 'create_stock_cat', 'create_stock_company', 'create_unit'
        ];
        const isDOMModalOpen = !!(document.querySelector('.modal_link') || document.querySelector('.modal_message'));
        const isBlockingModalOpen = standardModals.some(modal => modal_state?.[modal]) || isDOMModalOpen;

        if (isBlockingModalOpen || submitConfirm) return;

        if (nameInput?.current) {
            nameInput.current.focus();
        } else if (nameInput?.focus) {
            nameInput.focus();
        }
    }, [modal_state, nameInput, submitConfirm]);


    useEffect(() => {
        API_Function();
    }, [modal_state?.ledgerCreate]);


    const API_Function = useCallback(async () => {
        try {
            const formdata = new FormData();
            formdata.append('company_id', userData?.company_id);
            formdata.append('group_ids', `${userData?.group_data[4]?.id},${userData?.group_data[21]?.id},${userData?.group_data[5]?.id}`)
            const response = await dispatch(contraLedgerListing(formdata));
            if (response.status) {
                setcontra_account_ledger_list(response.data);
            }
        } catch (error) {
            console.log(error);
        }

        try {
            const formdata1 = new FormData();
            formdata1.append('company_id', userData?.company_id);
            formdata1.append('group_ids', `${userData?.group_data[0]?.id},${userData?.group_data[1]?.id},${userData?.group_data[3]?.id},${userData?.group_data[10]?.id},${userData?.group_data[6]?.id},${userData?.group_data[14]?.id},${userData?.group_data[15]?.id},${userData?.group_data[11]?.id},${userData?.group_data[16]?.id},${userData?.group_data[17]?.id},${userData?.group_data[18]?.id},${userData?.group_data[19]?.id},${userData?.group_data[7]?.id},${userData?.group_data[20]?.id},${userData?.group_data[24]?.id},${userData?.group_data[12]?.id},${userData?.group_data[25]?.id},${userData?.group_data[2]?.id},${userData?.group_data[26]?.id},${userData?.group_data[22]?.id},${userData?.group_data[13]?.id},${userData?.group_data[9]?.id}`)
            const response1 = await dispatch(contraLedgerListing(formdata1));
            if (response1.status) {
                setreciept_payment_account_ledger_list(response1.data);
            }
        } catch (error) {
            console.log(error);
        }
    }, []);


    const validateForm = () => {
        for (let { field, message } of requiredFields) {
            if (!data?.[field] || data[field].toString().trim() === "") {
                toast.error(message, {
                    position: toast.POSITION.TOP_CENTER,
                });
                setSubmitConfirm("");
                focusOnField(field);
                return false;
            }
        }
        return validateContraVoucher();
    };

    // Helper function to focus on a specific field
    const focusOnField = (fieldName) => {
        const currentRefs = inputRefs;
        if (currentRefs?.[fieldName]?.current) {
            setTimeout(() => {
                currentRefs[fieldName].current.focus();
                if (currentRefs[fieldName].current.value) {
                    currentRefs[fieldName].current.setSelectionRange(
                        0,
                        currentRefs[fieldName].current.value.length
                    );
                }
            }, 100);
        }
    };

    // Helper function to focus on dynamic field
    const focusOnDynamicField = (fieldName, index = 0) => {
        const item = data?.data?.[index];
        if (!item?.id) return;

        const itemId = item.id;

        const checkAndFocus = () => {
            const ref = dynamicInputRef?.current?.[itemId]?.[fieldName];
            if (ref) {
                if (document.body.contains(ref) || ref.isConnected) {
                    ref.focus();
                    if (ref.value) {
                        ref.setSelectionRange(0, ref.value.length);
                    }
                } else {
                    setTimeout(checkAndFocus, 50);
                }
            } else {
                setTimeout(checkAndFocus, 50);
            }
        };

        requestAnimationFrame(() => {
            setTimeout(checkAndFocus, 100);
        });
    };

    // Validate Contra vouchers
    const validateContraVoucher = () => {
        if (data.data.length === 0) {
            toast.error("At least one entry is required", {
                position: toast.POSITION.TOP_CENTER,
            });
            setSubmitConfirm("");
            focusOnDynamicField("first", 0);
            return false;
        }

        const validEntries = data.data.filter((item) => {
            const hasFirst = item?.first && item.first.toString().trim() !== "";
            const hasLedgerId = item?.particular_ledger_id && item.particular_ledger_id.toString().trim() !== "";
            const hasAmount = item?.particular_ledger_pay_amount && parseFloat(item.particular_ledger_pay_amount) > 0;
            return hasFirst && hasLedgerId && hasAmount;
        });

        if (validEntries.length === 0) {
            validateTransaction()
        } else {
            setData((prev) => ({
                ...prev,
                data: validEntries
            }));
        }

        // Check if total amount is greater than 0
        const totalAmount = data.data.reduce((sum, item) => {
            return sum + (parseFloat(item?.particular_ledger_pay_amount) || 0);
        }, 0);

        if (totalAmount <= 0) {
            toast.error("Total amount must be greater than 0", {
                position: toast.POSITION.TOP_CENTER,
            });
            setSubmitConfirm("");
            // Focus on the first amount field
            focusOnDynamicField("particular_ledger_pay_amount", 0);
            return false;
        }

        return true;
    };

    const validateTransaction = () => {
        for (let i = 0; i < data.data.length; i++) {
            const item = data.data[i];
            if (!item?.first || item.first.toString().trim() === "") {
                toast.error(
                    "At least one valid entry with amount greater than 0 is required",
                    {
                        position: toast.POSITION.TOP_CENTER,
                    }
                );
                setSubmitConfirm("");
                focusOnDynamicField("first", i);
                return false;
            }
            if (
                !item?.particular_ledger_id ||
                item.particular_ledger_id.toString().trim() === ""
            ) {
                toast.error(
                    "At least one valid entry with amount greater than 0 is required",
                    {
                        position: toast.POSITION.TOP_CENTER,
                    }
                );
                setSubmitConfirm("");
                focusOnDynamicField("first", i);
                return false;
            }
            if (
                !item?.particular_ledger_pay_amount ||
                parseFloat(item.particular_ledger_pay_amount) <= 0
            ) {
                toast.error(
                    "At least one valid entry with amount greater than 0 is required",
                    {
                        position: toast.POSITION.TOP_CENTER,
                    }
                );
                setSubmitConfirm("");
                focusOnDynamicField("particular_ledger_pay_amount", i);
                return false;
            }
        }

    }

    const resetForm = useCallback(async () => {
        setSubmitConfirm("");

        const fieldsToPreserve = [
            "period_key",
            "create_date",
            "voucher_type_name",
            "voucher_type_id",
            "select_type_of_voucher",
            "method_of_voucher_number",
            "day_name",
        ];

        // Helper function to build reset state
        const buildResetState = (prev) => ({
            ...initialState,
            company_id: userData?.company_id,
            data: initialState.data,
            // Preserve specified fields from previous state
            ...fieldsToPreserve.reduce((acc, field) => {
                acc[field] = prev?.[field] ?? "";
                return acc;
            }, {}),
        });
        setData((prev) => buildResetState(prev));
    }, [setData, userData?.company_id, initialState]);



    const { handleSubmit, loading: submitting, handleFocusReset } = useFormHandler({
        validateForm,
        prepareFormData: () => prepareFormData(data),
        submitForm: (formData) => dispatch(isAlter ? contraVoucherUpdate(formData) : contraVoucherCreate(formData)),
        shortcuts: [
            {
                key: "a",
                ctrlKey: true,
                action: () => handleSubmit(new Event("submit")),
            },
        ],
        resetForm: (isAlter || isView) ? () => navigate(-1) : resetForm,
        first_ref: inputRefs?.create_date,
        closeModal: () => {
            navigate(-1);
        },
        setSubmitConfirm,
        submitConfirm,
        setData,
        data,
        isView,
        isAlter,
        customFocusReset: () => {
            if (nameInput?.current) {
                nameInput.current.focus();
                nameInput.current.setSelectionRange(0, nameInput.current.value.length);
            } else if (nameInput?.focus) {
                nameInput.focus();
                nameInput.setSelectionRange(0, nameInput.value.length);
            }
        }
    });


    const handleClickOutside = (event) => {
        if (nameInput?.current) {
            event.preventDefault();
            nameInput.current.focus();
        } else if (nameInput?.focus) {
            event.preventDefault();
            nameInput.focus();
        }
    };

    const handleClickInside = (event) => {
        let clickedElement = event.target;
        if (
            clickedElement?.tagName &&
            (clickedElement?.tagName.toLowerCase() === "input" ||
                clickedElement?.tagName.toLowerCase() === "textarea")
        ) {
            clickedElement.focus();
        }
    };

    useClickOutside(nameInput, handleClickOutside, handleClickInside);


    const isCreateMasterEnabled = Object.keys(modal_state).some(key =>
        modal_state[key] && (key === 'account' || key.startsWith('first'))
    );
    return (
        <>
            <Form
                handleSubmit={handleSubmit}
                handleKeyDown={handleKeyDown}
                submitConfirm={submitConfirm}
                handleFocusReset={handleFocusReset}
                title={`${data?.voucher_type_name} Voucher ${isAlter ? "Alter" : isView ? "View" : (isDuplicate ? "Duplication" : "Creation")}`}
                loading={submitting}
                col="col-12"
                Footer={MasterCreationFooter}
                createMasterEnabled={isCreateMasterEnabled}
                isAlter={isAlter}
                isView={isView}
            >
                <div className="row p-0 m-0 mb-1">
                    <div className="col-6">
                        <div className="d-flex align-items-center" style={{ height: '3vh' }}>
                            <label className="lab_voucher_entry" style={{ whiteSpace: 'nowrap', flexShrink: 0, width: 'auto' }}>
                                {data?.voucher_type_name} No
                            </label>
                            <label style={{ flexShrink: 0, margin: '0 3px' }}>:</label>
                            {inputFields
                                .slice(0, 1)
                                .map(
                                    (
                                        { label, name, type, isRequired, isDisabled, autoFocus },
                                        index
                                    ) => (
                                        <input
                                            key={name}
                                            style={{ fontSize: 13, fontWeight: "bold", width: "25%" }}
                                            type={type}
                                            name={name}
                                            id={name}
                                            value={data[name] || ""}
                                            onChange={handleChange}
                                            onKeyUp={handleChange}
                                            onBlur={handleBlur}
                                            onFocus={handleFocus}
                                            isRequired={isRequired}
                                            ref={inputRefs[name]}
                                            disabled={isView || data?.method_of_voucher_number?.toLowerCase() !== "manual"}
                                        />
                                    )
                                )}
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="row justify-content-end">
                            <div className="col-6 d-flex justify-content-end">
                                {inputFields
                                    .slice(1, 2)
                                    .map(({ label, name, type, isRequired, autoFocus }, index) => (
                                        <React.Fragment key={name}>
                                            <label className="pe-2">{data?.day_name}</label>
                                            <input
                                                style={{
                                                    fontSize: 13,
                                                    textAlign: "right",
                                                    fontWeight: "bold",
                                                    width: "38%",
                                                    paddingRight: "2px",
                                                }}
                                                type={type}
                                                name={name}
                                                value={data[name] || ""}
                                                onChange={handleChange}
                                                onKeyUp={handleChange}
                                                onBlur={handleBlur}
                                                onFocus={handleFocus}
                                                isRequired={isRequired}
                                                ref={inputRefs[name]}
                                                disabled={isView}
                                            />
                                        </React.Fragment>
                                    ))}
                            </div>
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="d-flex align-items-center" style={{ height: '3vh' }}>
                            {/* Supplier Inv/Ref No */}
                            {inputFields.slice(2, 3).map(({ label, name, type, isRequired }, i) => (
                                <React.Fragment key={name}>
                                    <label style={{ whiteSpace: 'nowrap', flexShrink: 0, fontSize: 13 }}>
                                        {label}{isRequired ? <span className='star_color'>*</span> : null}
                                    </label>
                                    <label style={{ flexShrink: 0, margin: '0 3px', fontSize: 13 }}>:</label>
                                    <input
                                        style={{ fontSize: 13, fontWeight: 'bold', width: '35%' }}
                                        type={type}
                                        name={name}
                                        value={data[name] || ''}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        onFocus={handleFocus}
                                        ref={inputRefs[name]}
                                        disabled={isView}
                                    />
                                </React.Fragment>
                            ))}
                            {/* Date - inline right after */}
                            {inputFields.slice(3, 4).map(({ label, name, type, isRequired }, i) => (
                                <React.Fragment key={name}>
                                    <label style={{ whiteSpace: 'nowrap', flexShrink: 0, fontSize: 13, marginLeft: '12px' }}>
                                        {label}{isRequired ? <span className='star_color'>*</span> : null}
                                    </label>
                                    <label style={{ flexShrink: 0, margin: '0 3px', fontSize: 13 }}>:</label>
                                    <input
                                        style={{ fontSize: 13, fontWeight: 'bold', width: '20%' }}
                                        type={type}
                                        name={name}
                                        value={data[name] || ''}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        onFocus={handleFocus}
                                        ref={inputRefs[name]}
                                        disabled={isView}
                                    />
                                </React.Fragment>
                            ))}
                        </div>
                    </div>
                </div>
                {/* Row 3: Account + Current Balance */}
                <div className="row p-0 m-0 mb-1">
                    <div className="col-6">
                        {inputFields
                            .slice(4, 5)
                            .map(({ label, name, type, isRequired, autoFocus }, index) => (
                                <InputField
                                    key={index}
                                    lable={label}
                                    type={type}
                                    name={name}
                                    value={data[name] || ""}
                                    handleChange={handleChange}
                                    handleBlur={handleBlur}
                                    handleFocus={handleFocus}
                                    isRequired={isRequired}
                                    ref={inputRefs[name]}
                                    autoFocus={autoFocus}
                                    handleDropdownClick={handleDropdownClick}
                                    disabled={isView}
                                />
                            ))}

                        <div className="d-flex justify-content-between align-item-center">
                            <label
                                className="lab_voucher_entry text-muted"
                                style={{ width: "75%" }}
                            >
                                Current Balance{" "}
                            </label>
                            <label className="lab_colun_voucher_entry"> :</label>
                            <label
                                style={{ textAlign: "left" }}
                                className={`voucher_entry_account_input ${removeCurrencyComma(data?.account_ledger_balance) < 0
                                    ? "color_red ps-2"
                                    : "text-muted ps-2"
                                    }`}
                            >
                                {data?.account_ledger_balance !== null && data?.account_ledger_balance !== undefined && data?.account_ledger_balance !== ""
                                    ? currencyFormate(data?.account_ledger_balance)
                                    : ""}
                                <span
                                    className={
                                        removeCurrencyComma(data?.account_ledger_balance) < 0
                                            ? "color_red ps-1"
                                            : "m-0 p-0 ps-1 text-muted"
                                    }
                                >
                                    {data?.account_ledger_balance !== null && data?.account_ledger_balance !== undefined && data?.account_ledger_balance !== ""
                                        ? (removeCurrencyComma(data?.account_ledger_balance) < 0
                                            ? "Cr"
                                            : "Dr")
                                        : ""}
                                </span>
                            </label>
                        </div>

                        {
                            modal_state?.['account'] && (
                                <DropdownLayout_1
                                    key={'account'}
                                    title={"List of Ledger"}
                                    state={modal_state['account']}
                                    data={data}
                                    setData={setData}
                                    input_value={data['account']}
                                    input_key={'account'}
                                    input_blc={"account_ledger_balance"}
                                    input_id={"account_ledger_id"}
                                    rawData={contra_account_ledger_list || []}
                                    ref={inputRefs['account']}
                                    inputRefs={inputRefs}
                                    setSubmitConfirm={setSubmitConfirm}
                                    handleDropdownClick={handleDropdownClick}
                                />
                            )}
                    </div>
                </div>
                <TableHeader />
                <div
                    className="row p-0 m-0"
                    style={{ height: "56.5vh", overflowY: "scroll" }}
                >
                    <div className="col-12 p-0 m-0">
                        <VoucherContraInputRow
                            setValueLoop={setData}
                            valueLoop={data}
                            handleChange={handleItemUpdate}
                            handleFocus={handleDynamicFocus}
                            handleBlur={handleDynamicBlur}
                            isView={isView}
                            inputRefs={dynamicInputRef}
                            handleDropdownDynamicClick={handleDropdownDynamicClick}
                            handleKeyDown={handleKeyDown}
                            dropList={[
                                { id: "ed", ledger_name: "End of List" },
                                ...reciept_payment_account_ledger_list,
                            ]}
                        />
                    </div>
                </div>
                <div className="row p-0 m-0" style={{ width: "100%" }}>
                    <div className="col-6 m-0 p-0 ps-1 text-start  border-dark">
                        {inputFields
                            .slice(5)
                            .map(({ label, name, type, isRequired }, index) => (
                                <React.Fragment key={name}>
                                    <label>{label} </label>
                                    <div className="d-flex justify-content-between align-item-center">
                                        <textarea
                                            style={{ height: "7.5vh" }}
                                            lable={label}
                                            className="narration_input"
                                            type={type}
                                            name={name}
                                            value={data[name] || ""}
                                            onKeyUp={handleChange}
                                            onChange={handleChange}
                                            onFocus={handleFocus}
                                            isRequired={isRequired}
                                            ref={inputRefs[name]}
                                            disabled={isView}
                                        />
                                    </div>
                                </React.Fragment>
                            ))}
                    </div>
                    <Total_Amount_Row data={data} />
                </div>
            </Form>
            {modal_state?.ledgerCreate && (
                <LedgerCreate
                    title="Ledger Creation (Secondary)"
                    closeModal_sec={() => dispatch(closeModal("ledgerCreate"))}
                />
            )}
        </>
    );
};

export default RecieptPayment;
